var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVevoLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 25,
    viewBox: "0 0 100 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3745_304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7264 0C84.2541 -1.04095e-06 81.8374 0.73311 79.7818 2.10663C77.7262 3.48014 76.124 5.43238 75.1779 7.71645C74.2318 10.0005 73.9843 12.5139 74.4666 14.9386C74.9489 17.3634 76.1394 19.5907 77.8876 21.3388C79.6357 23.087 81.863 24.2775 84.2878 24.7598C86.7125 25.2421 89.2259 24.9946 91.5099 24.0485C93.794 23.1024 95.7463 21.5002 97.1198 19.4446C98.4933 17.389 99.2264 14.9723 99.2264 12.5C99.2264 9.1848 97.9094 6.00537 95.5652 3.66117C93.221 1.31696 90.0416 1.39588e-06 86.7264 0ZM86.7264 18.3333C83.6012 18.3333 81.3097 15.8333 81.3097 12.5C81.3097 9.16667 83.6031 6.66667 86.7264 6.66667C89.8514 6.66667 92.1431 9.16717 92.1431 12.5C92.1431 15.8328 89.8514 18.3333 86.7264 18.3333ZM50.0597 12.5C50.0597 5.59642 44.6499 0 37.9764 0C31.303 0 25.8931 5.59642 25.8931 12.5C25.8931 19.4036 31.309 25 38.1848 25C43.6766 25 47.9834 21.6807 49.4161 17.0833H42.1431C41.1341 18.5763 39.6505 18.9583 38.1848 18.9583C35.3737 18.9583 33.5825 17.0234 33.0204 14.375H49.924C50.0144 13.7541 50.0597 13.1275 50.0597 12.5ZM37.9764 5.83333C40.3874 5.83333 42.256 7.49421 42.8288 10H33.1145C33.7629 7.39521 35.4893 5.83333 37.9764 5.83333ZM13.8097 24.7917L0 0.729167H8.13066L13.8097 11.6667L19.4889 0.729167H27.6195L13.8097 24.7917ZM62.1431 24.7917L48.3333 0.729167H56.464L62.1431 11.6667L67.8222 0.729167H75.953L62.1431 24.7917Z",
    fill: "#EEE6DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3745_304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.2264,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVevoLogoIcon);
export default __webpack_public_path__ + "static/media/vevo_logo_icon.eade5cc98d9af3c851f1bf439c4d00c1.svg";
export { ForwardRef as ReactComponent };